"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var RequirementsUtility_1 = require("../../../utils/RequirementsUtility");
var ReceiverRequirements_1 = require("../../types/ReceiverRequirements");
var form_item_1 = __importDefault(require("../form-item"));
var react_intl_1 = require("react-intl");
var antd_1 = require("antd");
var translationMessages = react_intl_1.defineMessages({
    baseInformation_projectReferenceLabel: {
        id: "baseInformation_projectReferenceLabel",
        defaultMessage: "Project reference"
    },
});
var ProjectReference = function (props) {
    var projectReferenceFieldDefinition = RequirementsUtility_1.getFieldRequirements(props.receiverRequirements, ReceiverRequirements_1.AvailableFields['documentReferences.project.documentNo']);
    if (projectReferenceFieldDefinition) {
        return (react_1.default.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["documentReferences.project.documentNo"], defaultLabel: props.intl.formatMessage(translationMessages.baseInformation_projectReferenceLabel), defaultIsRequired: false, fieldName: ["invoice", "documentReferences", "project", "documentNo"] },
            react_1.default.createElement(antd_1.Input, null)));
    }
    else {
        return null;
    }
};
exports.default = react_intl_1.injectIntl(ProjectReference);
